  export class CreateCasosUsoRequest{
    public descripcion?: string
    public path?:string
    public icon?:string
    public idMenu?:number
  }
